import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  key: 1,
  class: "invoice-record"
};
var _hoisted_2 = {
  class: "line"
};
var _hoisted_3 = {
  class: "name"
};
var _hoisted_4 = {
  class: "detail"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  class: "value"
};
var _hoisted_8 = {
  class: "price"
};
var _hoisted_9 = {
  class: "line"
};
var _hoisted_10 = {
  class: "time"
};
import { ref, computed, watch } from "vue";
import { formatDateWithTZ } from "@/utils/format";
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import EmptyListPlaceholder from "../EmptyListPlaceholder.vue";
import { getInvoiceRecordList } from "@/api/invoice";
import { priceUtil } from "@op/shared";
import { CountryCurrencySymbolEnum } from "@/constant/currency";
import InvoiceStatusTag from "./InvoiceStatusTag.vue";
import { getSupplyId } from "@/utils/authUtil";
import { useUserStore } from "@/store/userStore";
import InvoiceTrigger from "./InvoiceTrigger.vue";
export default {
  __name: 'InvoiceRecordPopup',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:show"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var userStore = useUserStore();
    var emit = __emit;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    var loading = ref(false);
    var finished = ref(false);
    var items = ref([]);
    var pageNum = ref(1);
    var pageSize = ref(10);
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _userStore$getUserInf;
        var res, _res$data, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getInvoiceRecordList({
                page_num: pageNum.value,
                page_size: pageSize.value,
                company_id: getSupplyId(),
                user_id: (_userStore$getUserInf = userStore.getUserInfo) === null || _userStore$getUserInf === void 0 ? void 0 : _userStore$getUserInf.customer_id
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || [];
                if (data.length > 0) {
                  items.value = items.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onSuccess = function onSuccess() {
      finished.value = false;
      items.value = [];
      pageNum.value = 1;
      fetchData();
    };
    watch(showPopup, function () {
      if (showPopup.value) {
        finished.value = false;
        items.value = [];
        pageNum.value = 1;
        fetchData();
      }
    });
    return function (_ctx, _cache) {
      var _component_Button = _resolveComponent("Button");
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('record')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
              return loading.value = $event;
            }),
            finished: finished.value,
            "loading-text": _ctx.$t('loading'),
            class: "invoice-record-list",
            onLoad: fetchData
          }, {
            default: _withCtx(function () {
              return [finished.value && items.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
                key: 0,
                text: _ctx.$t('youHaveNoRecordYet'),
                class: "empty"
              }, null, 8, ["text"])) : _createCommentVNode("", true), items.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, function (item) {
                var _item$invoice_data, _item$invoice_data2, _item$order_info;
                return _openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "item"
                }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString((_item$invoice_data = item.invoice_data) === null || _item$invoice_data === void 0 || (_item$invoice_data = _item$invoice_data.buyer) === null || _item$invoice_data === void 0 ? void 0 : _item$invoice_data.name), 1), _createVNode(InvoiceStatusTag, {
                  value: item.status
                }, null, 8, ["value"])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "division"
                }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("eInvoiceID")), 1), _createElementVNode("div", _hoisted_7, _toDisplayString((_item$invoice_data2 = item.invoice_data) === null || _item$invoice_data2 === void 0 ? void 0 : _item$invoice_data2.doc_id), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice((_item$order_info = item.order_info) === null || _item$order_info === void 0 ? void 0 : _item$order_info.order_amount, _unref(CountryCurrencySymbolEnum)[item.country], true)), 1)]), _cache[3] || (_cache[3] = _createElementVNode("div", {
                  class: "division"
                }, null, -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatDateWithTZ)(item.create_at)), 1), _createVNode(InvoiceTrigger, {
                  class: "order-card_btn-container",
                  "order-id": item.order_info.order_id,
                  "shop-id": item.shop_id,
                  "record-id": item.id,
                  "order-type": item.order_info.order_type,
                  onSuccess: onSuccess
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_Button, {
                      class: "btn",
                      type: "border"
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(_ctx.$t("detail")), 1)];
                      }),
                      _: 1
                    })];
                  }),
                  _: 2
                }, 1032, ["order-id", "shop-id", "record-id", "order-type"])])]);
              }), 128))])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["loading", "finished", "loading-text"])];
        }),
        _: 1
      }, 8, ["show", "title"]);
    };
  }
};